import {ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges} from '@angular/core';
import {trackByProperty} from 'app/core/helpers/trackby';
import {PageTitleItemComponent} from 'app/shared/components/page-title-item/page-title-item.component';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'page-title-content',
    templateUrl: './page-title-content.component.html',
    styleUrls: ['./page-title-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageTitleContentComponent implements OnChanges {
    @Input() title: string = '';
    @HostBinding('class.new-layout')
    @Input()
    titleItems: any[];

    trackByTemplate = trackByProperty<PageTitleItemComponent>('content');

    constructor(private titleService: Title) {}

    ngOnChanges(): void {
        this.setPageTitle();
    }

    setPageTitle() {
        if (this.title) {
            this.titleService.setTitle(this.title);
        }
    }
}
